import { constantCreator } from '~/utils/constantsCreator';
import moment from 'moment-timezone';

const constant = constantCreator('session');
const appConstant = constantCreator('app');
import api from '~/utils/api';

export const LOGIN = constant('LOGIN', true);
export const SIGNUP = constant('SIGNUP', true);
export const LOGOUT = constant('LOGOUT', true);
const GET_NOTI_COUNT = constant('GET_NOTI_COUNT', true);
const GET_LATEST_MESSAGES = constant('GET_LATEST_MESSAGES', true);

const SET_IS_PAGE_CHANGED = constant('SET_IS_PAGE_CHANGED');
const SET_WITH_PROMO = constant('SET_WITH_PROMO');
const SET_PROMO_INPUT = constant('SET_PROMO_INPUT');
const OPEN_MOBILE_MENU = constant('OPEN_MOBILE_MENU');
const OPEN_LOGIN = constant('OPEN_LOGIN');
const OPEN_SIGNUP = constant('OPEN_SIGNUP');
const OPEN_FORGOT = constant('OPEN_FORGOT');
const OPEN_CLASSIFY_USER = constant('OPEN_CLASSIFY_USER');
const SET_LOGIN_SIGNUP_CB = constant('SET_LOGIN_SIGNUP_CB');
const ADD_TO_CONVERSION_SOURCE = constant('ADD_TO_CONVERSION_SOURCE', true);
// const FIRST = constant('FIRST');
const GET_INITIAL_DATA = appConstant('GET_INITIAL_DATA', true);
const SET_SESSION_DATA = appConstant('SET_SESSION_DATA', true);
export const GET_USER_DATA = appConstant('GET_USER_DATA', true);
const GET_SESSION_DATA = appConstant('GET_SESSION_DATA', true);
const SEND_FORGOT = constant('SEND_FORGOT', true);
const SET_LOCAL_SESSION_DATA = appConstant('SET_LOCAL_SESSION_DATA');
const SET_TRIGGER_SUB = appConstant('SET_TRIGGER_SUB');
const SET_TRIGGER_CLASS = appConstant('SET_TRIGGER_CLASS');
const LOG_CHANGE_PATH = appConstant('LOG_CHANGE_PATH');
const LOG_AVAILABLE_DATE_OPEN_CALENDAR = appConstant('LOG_AVAILABLE_DATE_OPEN_CALENDAR');
const LOG_AVAILABLE_DATE_SELECT_DATE = appConstant('LOG_AVAILABLE_DATE_SELECT_DATE');
const CLICK_CALL = appConstant('CLICK_CALL');
const LOG_FROM_CANCELLATION_POLICY_MODAL = constant('LOG_FROM_CANCELLATION_POLICY_MODAL');
const SET_REDIRECT_CALLBACK = constant('SET_REDIRECT_CALLBACK');
const SET_REGISTER_USER_TYPE = constant('SET_REGISTER_USER_TYPE');
const SET_AFFILIATE_DETAIL = constant('SET_AFFILIATE_DETAIL', true);
const SET_FLUENCER_DETAIL = constant('SET_FLUENCER_DETAIL', true);

import { LOAD_COMBINED_DYNAMIC } from '~/redux/reducers/info';

const initialState = {
  // ...userMe,
  data: {
    quantity: 2,
    childQuantity: 0,
    currency: 'THB',
    date: moment().add(1, 'day').startOf('day').toISOString(),
  },
  isSessionDataLoaded: false,
  promoInput: '',
  isOpenLogin: false,
  isOpenSignup: false,
  isOpenMobileMenu: false,
  isOpenClassifyUser: false,
  isOpenForgot: false,
  user: {},
  notifications: {},
  isLoggedIn: false,
  isNotification: false,
  loggingIn: false,
  signingUp: false,
  loginErrorMessage: '',
  signupErrorMessage: '',
  first: true,
  withPromo: false,
  oldPromo: false,
  isPageChanged: false,
  isSubscribeTriggered: false,
  isClassifyTriggered: false,
  loginSignupCallback: () => {},
  isLoadingSessionData: false,
  isSettingSessionData: false,
  redirectCallback: null,
  registerUserType: 'tr',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INITIAL_DATA.PENDING:
    // case FIRST:
      return { ...state, first: false };
    case OPEN_CLASSIFY_USER:
      return {
        ...state,
        isOpenClassifyUser: action.open,
      };
    case OPEN_LOGIN:
      return {
        ...state,
        isOpenLogin: action.open,
        loginErrorMessage: '',
      };
    case OPEN_SIGNUP:
      return {
        ...state,
        isOpenSignup: action.open,
        signupErrorMessage: '',
      };
    case OPEN_MOBILE_MENU:
      return {
        ...state,
        isOpenMobileMenu: action.open,
      };
    case OPEN_FORGOT:
      return {
        ...state,
        isOpenForgot: action.open,
        isOpenLogin: false,
      };
    case SET_SESSION_DATA.PENDING:
      return {
        ...state,
        isSettingSessionData: true,
        data: action.forceSet ? { ...state.data, ...action.data } : state.data,
      };
    case SET_SESSION_DATA.RESOLVED:
      return {
        ...state,
        isSettingSessionData: false,
        isSessionDataLoaded: true
      };
    case SET_SESSION_DATA.REJECTED:
      return {
        ...state,
        isSettingSessionData: false,
      };
    case SET_AFFILIATE_DETAIL.PENDING:
      return {
        ...state,
        isSettingSessionData: true,
      };
    case SET_AFFILIATE_DETAIL.RESOLVED:
      return {
        ...state,
        isSettingSessionData: false,
      };
    case SET_AFFILIATE_DETAIL.REJECTED:
      return {
        ...state,
        isSettingSessionData: false,
      };
    case SET_FLUENCER_DETAIL.PENDING:
      return {
        ...state,
        isFluencer: true,
      };
    case SET_FLUENCER_DETAIL.RESOLVED:
      return {
        ...state,
        isFluencer: false,
      };
    case SET_FLUENCER_DETAIL.REJECTED:
      return {
        ...state,
        isFluencer: false,
      };
    case SET_WITH_PROMO:
      return {
        ...state,
        withPromo: true,
      };
    case SET_PROMO_INPUT:
      return {
        ...state,
        promoInput: action.promo,
      };
    case SET_LOGIN_SIGNUP_CB:
      return {
        ...state,
        loginSignupCallback: action.callback,
      };
    case GET_USER_DATA.RESOLVED:
      return {
        ...state,
        user: action.data.user || {},
        isLoggedIn: action.data.isLoggedIn || false,
      };
    case GET_SESSION_DATA.PENDING:
      return {
        ...state,
        isLoadingSessionData: true
      };
    case GET_SESSION_DATA.RESOLVED:
      return {
        ...state,
        data: { ...initialState.data, ...(action.data || {}) },
        isLoadingSessionData: false
      };
    case GET_SESSION_DATA.REJECTED:
      return {
        ...state,
        isLoadingSessionData: false
      };
    case GET_NOTI_COUNT.PENDING:
      return {
        ...state,
        isNotification: true
      };
    case GET_NOTI_COUNT.RESOLVED:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          messageCount: action.data.message_unread_notification || 0,
          bookingCount: action.data.booking_unread_notification || 0,
        },
        isNotification: false
      };
    case GET_NOTI_COUNT.REJECTED:
      return {
        ...state,
        isNotification: false,
      };
    case GET_LATEST_MESSAGES.PENDING:
      return {
        ...state,
        isNotification: true
      };
    case GET_LATEST_MESSAGES.RESOLVED:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          latest_messages: action.data,
        },
        isNotification: false
      };
    case GET_LATEST_MESSAGES.REJECTED:
      return {
        ...state,
        isNotification: false
      };
    case LOAD_COMBINED_DYNAMIC.RESOLVED:
      return {
        ...state,
        data: action.data.sessionData || {},
        isSessionDataLoaded: true,
        user: (action.data.userData && action.data.userData.user) || {},
        isLoggedIn: (action.data.userData && action.data.userData.isLoggedIn) || false,
      };
    case LOGIN.PENDING:
      return {
        ...state,
        loggingIn: true,
        loginErrorMessage: '',
      };
    case LOGIN.RESOLVED:
      if (window.zE && window.zE.identify && action.data.user) {
        window.zE.identify({
          name: `${action.data.user.name.first} ${action.data.user.name.last}`,
          email: action.data.user.email,
        });
      }
      return {
        ...state,
        ...action.data,
        loggingIn: false,
        // isOpenLogin: false,
        // isOpenSignup: false,
        loginErrorMessage: '',
      };
    case LOGOUT.RESOLVED:
      return {
        ...state,
        user: {},
        notifications: {},
        isLoggedIn: false,
      };
    case LOGIN.REJECTED:
      return {
        ...state,
        loggingIn: false,
        loginErrorMessage: action.error.message,
      };
    case SIGNUP.PENDING:
      return {
        ...state,
        signingUp: true,
        signupErrorMessage: '',
      };
    case SIGNUP.RESOLVED:
      if (window.zE && window.zE.identify && action.data.user) {
        window.zE.identify({
          name: `${action.data.user.name.first} ${action.data.user.name.last}`,
          email: action.data.user.email,
        });
      }
      return {
        ...state,
        ...action.data,
        signingUp: false,
        // isOpenSignup: false,
        signupErrorMessage: '',
      };
    case SIGNUP.REJECTED:
      return {
        ...state,
        signingUp: false,
        signupErrorMessage: action.error.message,
      };
    case SET_LOCAL_SESSION_DATA:
      return {
        ...state,
        data: { ...state.data, ...action.data },
      };
    case SET_IS_PAGE_CHANGED:
      return {
        ...state,
        isPageChanged: action.active,
      };
    case SET_TRIGGER_SUB:
      return {
        ...state,
        isSubscribeTriggered: action.active,
      };
    case SET_TRIGGER_CLASS:
      return {
        ...state,
        isClassifyTriggered: action.active,
      };
    case SET_REDIRECT_CALLBACK:
      return {
        ...state,
        redirectCallback: action.callback
      };
    case SET_REGISTER_USER_TYPE:
      return {
        ...state,
        registerUserType: action.userType
      };
    default:
      return state;
  }
};

export const actions = {
  // setFirst: () => ({
  //   type: FIRST,
  // }),
  openLogin: (open = true) => ({
    type: OPEN_LOGIN,
    open,
  }),
  openSignup: (open = true) => ({
    type: OPEN_SIGNUP,
    open,
  }),
  openMobileMenu: (open = true) => ({
    type: OPEN_MOBILE_MENU,
    open,
  }),
  setWithPromo: (active = true) => ({
    type: SET_WITH_PROMO,
    active,
  }),
  setPromoInput: (promo = '') => ({
    type: SET_PROMO_INPUT,
    promo,
  }),
  // login: (data, append = false) => {
  //   const queryStr = [
  //     `city=${data.city || 'Bangkok'}`,
  //     `skip=${data.skip || 0}&limit=10`,
  //   ];
  //   return {
  //     type: SEARCH,
  //     promise: api.get(`/experience/types/${data.id}?${queryStr.join('&')}`),
  //     append,
  //   };
  // },
  login: data => ({
    type: LOGIN,
    promise: api.post('/session/login', data).then(() => api.get('/users/me')),
    // .then(res => {
    // if (res.ok) return api.get('/users/me');
    // return res.json().then(error => Promise.reject(error));
    // }),
  }),
  logout: () => ({
    type: LOGOUT,
    promise: api.delete('/session/logout'),
    // .then(() => api.get('/users/me'))
  }),
  facebookLogin: accessToken => ({
    type: LOGIN,
    promise: api
      .post('/session/login/provider/facebook', { accessToken })
      .then(() => api.get('/users/me')),
    // .then(res => {
    //   if (res.ok) return api.get('/users/me');
    //   return res.json().then(error => Promise.reject(error));
    // }),
  }),
  googleLogin: accessToken => ({
    type: LOGIN,
    promise: api
      .post('/session/login/provider/google', { id_token: accessToken })
      .then(() => api.get('/users/me')),
    // .then(res => {
    //   if (res.ok) return api.get('/users/me');
    //   return res.json().then(error => Promise.reject(error));
    // }),
  }),
  mobileConnectLogin: data => ({
    type: LOGIN,
    promise: api
      .post('/session/login/provider/mobileconnect', data)
      .then(() => api.get('/users/me')),
  }),
  signup: data => ({
    type: SIGNUP,
    promise: api.post('/session/signup', data).then(() => api.get('/users/me')),
    //   if (res.ok) return api.get('/users/me');
    //   return res.json().then(error => Promise.reject(error));
    // }),
  }),
  setAffiliateDetail: (data) => ({
    type: SET_AFFILIATE_DETAIL,
    promise: api.post('/affiliate/detail', { affiliate_detail: data }),
  }),
  setAffiliateInfluencer: (data) => ({
    type: SET_FLUENCER_DETAIL,
    promise: api.post('/influencer/detail', { influencer_detail: data }),
  }),
  getSessionData: () => ({
    type: GET_SESSION_DATA,
    promise: api.get('/session/data'),
  }),
  getUserData: () => ({
    type: GET_USER_DATA,
    promise: api.get('/users/me'),
  }),
  getNotiCount: () => ({
    type: GET_NOTI_COUNT,
    promise: api.get('/users/me/notifications/count')
  }),
  getLatestMessages: () => ({
    type: GET_LATEST_MESSAGES,
    promise: api.get('/users/me/notifications/latest-messages')
  }),
  setSessionData: (data, forceSet = false) => ({
    type: SET_SESSION_DATA,
    promise: api.post('/session/data', data),
    data,
    forceSet,
  }),
  setLocalSessionData: data => ({
    type: SET_LOCAL_SESSION_DATA,
    data,
  }),
  openClassifyUser: (open = true) => ({
    type: OPEN_CLASSIFY_USER,
    open,
  }),
  openForgot: (open = true) => ({
    type: OPEN_FORGOT,
    open,
  }),
  setIsPageChanged: (active = true) => ({
    type: SET_IS_PAGE_CHANGED,
    active,
  }),
  setLoginSignupCallback: callback => ({
    type: SET_LOGIN_SIGNUP_CB,
    callback,
  }),
  setTriggerSubscribed: (active = true) => ({
    type: SET_TRIGGER_SUB,
    active,
  }),
  setTriggerClassify: (active = true) => ({
    type: SET_TRIGGER_CLASS,
    active,
  }),
  sendForgot: email => ({
    type: SEND_FORGOT,
    promise: api.post('/users/mail/forgot', { email }),
  }),
  logChangePath: path => ({
    type: LOG_CHANGE_PATH,
    path,
  }),
  logAvailableDateOpenCalendar: () => ({
    type: LOG_AVAILABLE_DATE_OPEN_CALENDAR
  }),
  logAvailableDateSelectDate: (date) => ({
    type: LOG_AVAILABLE_DATE_SELECT_DATE,
    date
  }),
  clickCall: () => ({
    type: CLICK_CALL,
  }),
  addToConversionSource: (source, tripId, topicId) => ({
    type: ADD_TO_CONVERSION_SOURCE,
    promise: api.post('/session/conversion-source', {
      source, tripId, topicId, path: window ? window.location.pathname : 'no-path'
    })
  }),
  logFromCancellationPolicyModal: () => ({
    type: LOG_FROM_CANCELLATION_POLICY_MODAL,
  }),
  setRedirectCallback: (callback) => ({
    type: SET_REDIRECT_CALLBACK,
    callback
  }),
  setRegisterUserType: userType => ({
    type: SET_REGISTER_USER_TYPE,
    userType
  })
};

export default reducer;

export const analytics = {
  [LOG_CHANGE_PATH]: action => ({
    name: 'Page View',
    category: 'pageview',
    providers: 'database',
    path: action.path,
  }),
  [LOG_AVAILABLE_DATE_OPEN_CALENDAR]: () => ({
    name: 'Open Available Date Calendar',
    category: 'Experience Available Date',
    providers: 'database',
  }),
  [LOG_AVAILABLE_DATE_SELECT_DATE]: action => ({
    name: 'Select Date in Calendar',
    category: 'Experience Available Date',
    providers: 'database',
    date: action.date,
  }),
  [CLICK_CALL]: () => ({
    name: 'Click Call',
    category: 'Session'
  }),
  [LOG_FROM_CANCELLATION_POLICY_MODAL]: () => ({
    name: 'Land from Cancellation Policy Modal',
    category: 'help-center',
    providers: 'database',
  })
};
